<ion-app>
  @if (session() || isSignedIn()) {
  <ion-router-outlet id="router-outlet" #outlet></ion-router-outlet>
  <app-tracking-banner></app-tracking-banner>
  } @else if (!onboardingComplete()) {
  <app-onboarding
    class="w-full h-full"
    #onboarding
    (completeOnboarding)="completeOnboarding()"
  ></app-onboarding>
  } @else {
  <app-auth #auth></app-auth>
  }
</ion-app>
